<template>
  <div>
    <v-container
      id="input-usage"
      grid-list-xl
      fluid
    >
      <v-text-field
        v-model="email"
        label="E-mail"
        @update:error="onError"
      ></v-text-field>
      <v-btn :disabled="!email" @click="addEmail" :loading="loading"> Προσθήκη</v-btn>
    </v-container>
  </div>
</template>

<script>
  import ApiData from "../assets/ApiData";

  export default {
    name: "AddEmail",
    data: () => ({
      canAdd: false,
      loading:false,
      email:"",
      rules: {
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Το email δεν έχει σωστό φορμάτ.'
        }
      }
    }),
    props:{customer:Object},
    methods:{
      onError(val){
        this.canAdd = !val;
      },
      addEmail(){
        this.loading = true;
        ApiData.addExtraEmail(this.customer.ID,this.email ).then(resp=>{
          if(resp.emailID){
            this.$notify({
              group: 'messages',
              type: 'success',
              text: 'Αποθηκεύτηκε'
            });
            this.loading = false;
            this.$emit('addedEmail',{EmailID:resp.emailID,CustomerID:this.customer.ID,Email:this.email})
            this.email = "";

          }
        }).catch(err=>{
          this.$notify({
            group: 'messages',
            type: 'error',
            text: 'Υπήρξε κάποιο πρόβλημα στην αποθήκευση'+err
          });
        })
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AddEmail.vue